(() => {
  const selector = '.csg-product-gallery.media-gallery--layout-carousel-beside .csg-thumb-rail';
  const desktop = window.matchMedia('(min-width: 1041px)');
  const galleries = new Set();

  function updateRail(rail) {
    const scroller = rail.querySelector('.slider');
    const grid = rail.querySelector('.slider__grid');
    if (!scroller || !grid) return;

    if (!desktop.matches) {
      rail.classList.remove('csg-thumb-rail--scrollable');
      return;
    }

    const scrollable = grid.scrollHeight > rail.clientHeight + 2;
    rail.classList.toggle('csg-thumb-rail--scrollable', scrollable);

    const top = scroller.scrollTop;
    const bottom = scroller.scrollHeight - scroller.clientHeight;
    const previous = rail.querySelector('.csg-thumb-rail__button--prev');
    const next = rail.querySelector('.csg-thumb-rail__button--next');
    previous.disabled = !scrollable || top <= 2;
    next.disabled = !scrollable || top >= bottom - 2;
  }

  function scrollToActive(rail) {
    if (!desktop.matches) return;

    const scroller = rail.querySelector('.slider');
    const active = rail.querySelector('.slider__item.is-active:not([hidden])');
    if (!scroller || !active) return;

    const viewport = scroller.getBoundingClientRect();
    const thumb = active.getBoundingClientRect();
    const visibleSlides = [...rail.querySelectorAll('.slider__item:not([hidden])')];
    if (active === visibleSlides[visibleSlides.length - 1] && thumb.bottom > viewport.bottom) {
      scroller.scrollTo({ top: scroller.scrollHeight - scroller.clientHeight, behavior: 'smooth' });
    } else if (thumb.top < viewport.top) {
      scroller.scrollBy({ top: thumb.top - viewport.top, behavior: 'smooth' });
    } else if (thumb.bottom > viewport.bottom) {
      scroller.scrollBy({ top: thumb.bottom - viewport.bottom, behavior: 'smooth' });
    }
  }

  function navigate(rail, direction) {
    if (!desktop.matches) return;

    const scroller = rail.querySelector('.slider');
    const slides = [...rail.querySelectorAll('.slider__item:not([hidden])')];
    if (!scroller || slides.length === 0) return;

    const viewport = scroller.getBoundingClientRect();
    const top = scroller.scrollTop;
    const offsets = slides.map((slide) => slide.getBoundingClientRect().top - viewport.top + top);
    const offset = direction > 0
      ? offsets.find((value) => value > top + 2)
      : offsets.filter((value) => value < top - 2).pop();

    if (typeof offset === 'number') {
      scroller.scrollTo({ top: offset, behavior: 'smooth' });
    } else {
      const height = slides[0].getBoundingClientRect().height || 65;
      scroller.scrollBy({ top: direction * height, behavior: 'smooth' });
    }
  }

  function initialise(rail) {
    if (rail.dataset.csgThumbRailInitialised === 'true') return;
    rail.dataset.csgThumbRailInitialised = 'true';
    galleries.add(rail);

    const scroller = rail.querySelector('.slider');
    const grid = rail.querySelector('.slider__grid');
    if (!scroller || !grid) return;

    rail.addEventListener('click', (event) => {
      const button = event.target.closest('.csg-thumb-rail__button');
      if (!button || button.disabled) return;
      event.preventDefault();
      navigate(rail, Number(button.dataset.csgThumbDirection));
    });

    let pending = false;
    const refresh = () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        updateRail(rail);
      });
    };

    scroller.addEventListener('scroll', refresh, { passive: true });
    rail.closest('media-gallery')?.addEventListener('on:media-gallery:change', () => {
      scrollToActive(rail);
      refresh();
    });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(refresh);
      resizeObserver.observe(rail);
      resizeObserver.observe(grid);
    }

    const mediaObserver = new MutationObserver(() => {
      refresh();
    });
    mediaObserver.observe(grid, {
      subtree: true,
      attributes: true,
      attributeFilter: ['hidden', 'class']
    });

    refresh();
    requestAnimationFrame(() => scrollToActive(rail));
  }

  function setup(scope = document) {
    if (scope.matches?.(selector)) initialise(scope);
    scope.querySelectorAll?.(selector).forEach(initialise);
  }

  function onBreakpointChange() {
    for (const rail of galleries) {
      if (!rail.isConnected) {
        galleries.delete(rail);
        continue;
      }
      updateRail(rail);
      if (desktop.matches) scrollToActive(rail);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', (event) => setup(event.target));
  desktop.addEventListener('change', onBreakpointChange);
})();
